import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          opacity: 0
        })
      ],
      { optional: true }
    ),
    query(':enter', [style({ opacity: 0, transform: 'translateY(10px)' })], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate('200ms ease-out', style({ opacity: 0, transform: 'translateY(-10px)' }))], {
        optional: true
      }),
      query(':enter', [animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))], {
        optional: true
      })
    ]),
    query(':enter', animateChild(), { optional: true })
  ])
]);

export const fadeInAnimation = trigger('fadeIn', [
  transition(':enter', [style({ opacity: 0 }), animate('300ms ease-in', style({ opacity: 1 }))])
]);

export const listAnimation = trigger('listAnimation', [
  transition('* <=> *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(15px)' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ],
      { optional: true }
    )
  ])
]);

export const staggerAnimation = trigger('staggerAnimation', [
  transition('* <=> *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('400ms 100ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ],
      { optional: true }
    )
  ])
]);
